import Vue from 'vue';
import {Component, Prop as prop, Watch as watch} from 'vue-property-decorator';
import {FileMapping} from '@/types/data';
import FileList from '../file-list/file-list.vue';
import {Constants as constants} from '../../../../config/constants';
import {EventFactory} from '@/app/factory/eventFactory';

@Component({
    components: {
        'file-list': FileList
    }
})
export default class MainComponent extends Vue {
    public currentDate = (new Date()).toISOString().split('T')[0];
    public minDate = (new Date()).toISOString().split('T')[0];
    public isContentHidden = true;
    public fileCollection = [] as FileMapping[];

    @prop()
    private files: FileMapping[] | undefined;

    public toggleMenu() {
        this.isContentHidden = !this.isContentHidden;
    }

    @watch('fileCollection')
    private onFileListChange() {
        EventFactory.generateReinitChartEvent({
            files: this.fileCollection,
            dueDate: this.currentDate
        });
    }

    @watch('currentDate')
    private onCurrentDateChange() {
        EventFactory.generateReinitChartEvent({
            files: this.fileCollection,
            dueDate: this.currentDate
        });
    }

    private setViewEventHandlers() {
        this.$on(constants.fileEvents.remove, (index: number) => {
            this.fileCollection.splice(index, 1);
        });
        this.$on(constants.fileEvents.add, (file: FileMapping) => {
           this.fileCollection.push(file);
        });
    }

    private mounted() {
        // @ts-ignore
        this.fileCollection = this.files;
        this.setViewEventHandlers();
    }
}
